var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.63,
    height: 21.676,
    viewBox: "0 0 21.63 21.676",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fe5969;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13.838)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.005 4.4)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M77.8,98.512l-1.458,15.542H65.658L64.2,98.512l-1.847.151,1.484,15.824a1.526,1.526,0,0,0,1.54,1.3H76.626a1.528,1.528,0,0,0,1.542-1.312l1.483-15.814Z",
    transform: "translate(-62.354 -98.512)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.709)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M153.64,0h-6.8A1.547,1.547,0,0,0,145.3,1.545V4.48h1.854V1.854h6.18V4.48h1.854V1.545A1.547,1.547,0,0,0,153.64,0Z",
    transform: "translate(-145.297)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.838 3.553)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M34.541,79.568H14.765a.927.927,0,1,0,0,1.854H34.541a.927.927,0,1,0,0-1.854Z",
    transform: "translate(-13.838 -79.568)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.0dd71e62.svg";
export { ForwardRef as ReactComponent };